import * as types from '../types.js';
import { formatLotNumber } from '../../versa/misc.js';

export default async function(records)
{
	return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(3)	{ text-align: right; }
			.view td:nth-child(n+4):nth-child(-n+19)	{ text-align: left; max-width: 12rem; }
			.view td:nth-child(20)	{ text-align: right; }
			.view td:nth-child(n+22):nth-child(-n+24)	{ text-align: right; }
			.view td:nth-child(25)	{ text-align: left; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar seleções"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="2" data-visible="${this.visible[1]}">Estoque</th>
					<th data-index="3" data-visible="${this.visible[2]}">SKU</th>
					<th data-index="4" data-visible="${this.visible[3]}">Produto</th>
					<th data-index="5" data-visible="${this.visible[4]}">NCM</th>
					<th data-index="6" data-visible="${this.visible[5]}">EAN</th>
					<th data-index="7" data-visible="${this.visible[6]}">Emb.</th>
					<th data-index="8" data-visible="${this.visible[7]}">Fator</th>
					<th data-index="9" data-visible="${this.visible[8]}">QR Emb.</th>
					<th data-index="10" data-visible="${this.visible[9]}">Lote fab.</th>
					<th data-index="11" data-visible="${this.visible[10]}">Validade</th>
					<th data-index="12" data-visible="${this.visible[11]}">Fabricação</th>
					<th data-index="13" data-visible="${this.visible[12]}">Programa</th>
					<th data-index="14" data-visible="${this.visible[13]}">Data Entrada</th>
					<th data-index="15" data-visible="${this.visible[14]}">Entrada Sial</th>
					<th data-index="16" data-visible="${this.visible[15]}">Nota Entrada</th>
					<th data-index="17" data-visible="${this.visible[16]}">Fornecedor</th>
					<th data-index="18" data-visible="${this.visible[17]}">Armazém</th>
					<th data-index="19" data-visible="${this.visible[18]}">Posição</th>
					<th data-index="20" data-visible="${this.visible[19]}">Titular</th>
					<th data-index="21" data-visible="${this.visible[20]}">Lote</th>
					<th data-index="22" data-visible="${this.visible[21]}">Disponível</th>
					<th data-index="23" data-visible="${this.visible[22]}">Reservado</th>
					<th data-index="24" data-visible="${this.visible[23]}">Bloqueado</th>
					<th data-index="25" data-visible="${this.visible[24]}">Status</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async record => 
				`<tr data-id='${JSON.stringify([record.company_id, record.id])}'> <td><input type="checkbox"${this.isChecked(JSON.stringify([record.company_id, record.id]))}></td>
					<td data-visible='${this.visible[0]}'>${await this.key('companies', record.company_id, 'nick')}</td>
					<td data-visible='${this.visible[1]}'>${record.id}</td>
					<td data-visible='${this.visible[2]}'>${(record.sku ?? '').toString()}</td>
					<td data-visible='${this.visible[3]}'>${(record.product_name ?? '').toString()}</td>
					<td data-visible='${this.visible[4]}'>${(record.ncm ?? '').toString()}</td>
					<td data-visible='${this.visible[5]}'>${(record.gtin ?? '').toString()}</td>
					<td data-visible='${this.visible[6]}'>${(record.packaging_code ?? '').toString()}</td>
					<td data-visible='${this.visible[7]}'>${this.format(types.number(0), record.packaging_factor) ?? ''}</td>
					<td data-visible='${this.visible[8]}'>${(record.packaging_qr_code ?? '').toString()}</td>
					<td data-visible='${this.visible[9]}'>${formatLotNumber(record.lot_number)}</td>
					<td data-visible='${this.visible[10]}'>${record.expiration_date ?? ''}</td>
					<td data-visible='${this.visible[11]}'>${record.manufacture_date ?? ''}</td>
					<td data-visible='${this.visible[12]}'>${(record.program_name ?? '').toString()}</td>
					<td data-visible='${this.visible[13]}'>${this.format(types.date(), record.input_created_on) ?? ''}</td>
					<td data-visible='${this.visible[14]}'>${record.input_id ?? ''}</td>
					<td data-visible='${this.visible[15]}'>${(record.invoice_number ?? '').toString()}</td>
					<td data-visible='${this.visible[16]}'>${(record.supplier_name ?? '').toString()}</td>
					<td data-visible='${this.visible[17]}'>${await this.key('warehouses', [record.company_id, record.warehouse_id])}</td>
					<td data-visible='${this.visible[18]}'>${await this.key('locations', [record.company_id, record.warehouse_id, record.location_id], 'address')}</td>
					<td data-visible='${this.visible[19]}'>${await this.key('companies', record.lot_company_id, 'nick')}</td>
					<td data-visible='${this.visible[20]}'>${record.lot_id}</td>
					<td data-visible='${this.visible[21]}'>${this.format(types.number(0), record.quantity_available)}</td>
					<td data-visible='${this.visible[22]}'>${this.format(types.number(0), record.quantity_reserved)}</td>
					<td data-visible='${this.visible[23]}'>${this.format(types.number(0), record.quantity_unsettled)}</td>
					<td data-visible='${this.visible[24]}'>${this.option(types.opt_stock_status(), record.status)}</td>
				</tr>`
				))).join('') +
			`
			</tbody>
		</table>
	`;
};

